module.exports = __webpack_public_path__ + "img/personality.62c091cc.svg";